var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApprovedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0001 15L13.6667 17.6667L19.6667 11.6667M8.77844 4.0916C9.85022 4.00607 10.8677 3.58461 11.686 2.88723C13.5957 1.25982 16.4044 1.25982 18.3141 2.88723C19.1325 3.58461 20.1499 4.00607 21.2217 4.0916C23.7228 4.29119 25.7089 6.27726 25.9085 8.77836C25.994 9.85014 26.4155 10.8676 27.1129 11.686C28.7403 13.5956 28.7403 16.4044 27.1129 18.314C26.4155 19.1324 25.994 20.1499 25.9085 21.2216C25.7089 23.7227 23.7228 25.7088 21.2217 25.9084C20.1499 25.9939 19.1325 26.4154 18.3141 27.1128C16.4044 28.7402 13.5957 28.7402 11.686 27.1128C10.8677 26.4154 9.85022 25.9939 8.77844 25.9084C6.27734 25.7088 4.29126 23.7227 4.09167 21.2216C4.00615 20.1499 3.58469 19.1324 2.88731 18.314C1.2599 16.4044 1.2599 13.5956 2.88731 11.686C3.58469 10.8676 4.00615 9.85014 4.09167 8.77836C4.29126 6.27726 6.27734 4.29119 8.77844 4.0916Z",
    stroke: "#18AB27",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedIcon);
export default __webpack_public_path__ + "static/media/approvedIcon.e3b1b0a0dac6f802d1d2be296691d4db.svg";
export { ForwardRef as ReactComponent };